import 'moment-timezone';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import {IconFillingColoured} from "site-apps/assets/AssetColorsIcons";
import {CONTAINER_STATUS_ACTIVE} from "./ModelsDynamic";

// Seleccionado (se evalúa) / no activo / contenedor en estado no activo
const SelectedIcon = ({item}) => {
    if (!item.active) {
        return <FontAwesomeIcon icon="eye-slash" title="No activo"/>;
    }
    if (item.status !== CONTAINER_STATUS_ACTIVE) {
        return <FontAwesomeIcon icon="eye-slash" className="text-secondary" title="Estado del contenedor no activo"/>;
    }
    return <FontAwesomeIcon icon="eye" title="Seleccionado"/>;
};

const TabFiltersTableAssets = ({items}) => {

    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th style={{width: "40px"}}></th>
                <th>UID</th>
                <th width={{width: "70px"}}></th>
                <th>Grupo</th>
                <th>Zona</th>
                <th>Isla</th>
                <th>Rutas</th>
            </tr>
            </thead>
            <tbody>
            {items.map((item, index) => (
                <tr key={index} data-idx={index}>
                    <td className="text-center align-middle">
                        <SelectedIcon item={item}/>
                    </td>
                    <td>
                        <div>{item.uid}</div>
                        <div>{item.full_address}</div>
                        <small>{item.uuids}</small>
                    </td>
                    <td className="text-end">
                        <div><IconFillingColoured value={item.filling}/></div>
                        <div>
                            {
                                item.has_device
                                    ? <FontAwesomeIcon icon="wifi" title="Tiene sensor" className="text-secondary"/>
                                    : <></>
                            }
                        </div>
                        <div>
                            {
                                item.has_route
                                    ? <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" className="text-secondary"/>
                                    : <></>
                            }
                        </div>
                    </td>
                    <td>{item.group_name}</td>
                    <td>{item.zone_name}</td>
                    <td>{item.island_name}</td>
                    <td>{item.routes_name}</td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default TabFiltersTableAssets

